import { useState } from 'react'

import { useConfigureModalController, useModalController, useCloseModal } from '@/atoms'

type ModalState = 'ready' | 'submitting'
type ModalData = {
  driverId: string
}

export const modalId = 'changeDriverPassword'

export const useController = () => useModalController<ModalData, ModalState>(modalId)

export const useConfigureController = (driverId: string) => {
  const close = useCloseModal()

  // INITIALIZATION

  const [options] = useState(() => ({
    createInitialState: () => ({
      close,
      data: {
        driverId,
      },
    }),
  }))

  return useConfigureModalController<ModalData, ModalState>(modalId, options)
}
